// extracted by mini-css-extract-plugin
module.exports = {"UserMessageArea":"UserMessage_UserMessageArea__WJsiP","date":"UserMessage_date__enwVd"};